import { Navigate, useParams } from 'react-router-dom';
import { AxiosError } from 'axios';
import { IErrorResponse } from '../../../interfaces/errorResponse';
import { ICustomerFullProfile } from '../../../interfaces/customer';
import { ColumnBoxFlexFullWidth } from '../../common/boxes';
import { Loader } from '../../common/Loader';
import { createContext, Dispatch, SetStateAction, useState } from 'react';
import { useNotification } from '../../../+state/useNotification';
import { parseAxiosError } from '../../../services/axios';
import { TEXTS } from '../../../core/texts';
import { CLIENTS_PATH } from '../../../router/paths';
import ClientPersonalInfo from './ClientPersonalInfo';
import { useGetClientEntity } from '../../../queryHooks/client/useGetClientEntity';

interface IClientContext {
  user: ICustomerFullProfile;
  setUser: Dispatch<SetStateAction<ICustomerFullProfile | null>>;
}
export const ClientContext = createContext<IClientContext>({} as IClientContext);

const FreelancerEntity = () => {
  const { id } = useParams();
  const { openErrorToast, openInfoToast } = useNotification();
  const [forceNavigate, setForceNavigate] = useState(false);
  const [user, setUser] = useState<ICustomerFullProfile | null>(null);

  const { isLoading } = useGetClientEntity({
    id: +id!,
    onSuccess: (user) => {
      if (!user.clientProfile) {
        openInfoToast(TEXTS.INCONSISTENT_CUSTOMER_TYPE);
        return setForceNavigate(true);
      }
      setUser(user);
    },
    onError: (err: AxiosError<IErrorResponse>) => {
      openErrorToast(parseAxiosError(err));
      setForceNavigate(true);
    }
  });

  return (
    <ColumnBoxFlexFullWidth alignItems={'center'}>
      {
        isLoading && <Loader/>
      }
      {
        user && user.clientProfile &&
        <ClientContext.Provider value={{ user, setUser }}>
          <ColumnBoxFlexFullWidth maxWidth={800}>
            <ClientPersonalInfo/>
          </ColumnBoxFlexFullWidth>
        </ClientContext.Provider>
      }
      {
        forceNavigate &&
        <Navigate to={CLIENTS_PATH}/>
      }
    </ColumnBoxFlexFullWidth>
  );
};

export default FreelancerEntity;